module.exports = __webpack_public_path__ + "static/media/01B.2d442a46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/01B.png
// module id = 258
// module chunks = 0